import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  ConfirmResult,
  OutboundDetail,
  OutboundListQuery,
  OutboundPickRequest,
  OutboundPickResult,
  OutboundRow
} from '../types/inventoryDoc';
import type { PageResult } from '../types/result';

const BASE = '/wl/outbound';

/** 出库单：查询 + 确认（确认扣减库存并写流水）。 */
export function createOutboundApi(http: HttpClient) {
  return {
    list(query: OutboundListQuery = {}): Promise<PageResult<OutboundRow>> {
      return http.request<PageResult<OutboundRow>>({ path: BASE, query: toQuery(query) });
    },

    detail(id: Id): Promise<OutboundDetail> {
      return http.request<OutboundDetail>({ path: `${BASE}/${id}` });
    },

    /** 确认出库：整单按拣货/计划数量扣减，库存不足整单回滚。 */
    confirm(id: Id): Promise<ConfirmResult> {
      return http.request<ConfirmResult>({ path: `${BASE}/${id}/confirm`, method: 'POST' });
    },

    /** 拣货登记：记录明细拣货量与货位，推进 PICKING/PICKED（不扣库存）。 */
    pick(id: Id, body: OutboundPickRequest): Promise<OutboundPickResult> {
      return http.request<OutboundPickResult>({ path: `${BASE}/${id}/pick`, method: 'POST', body });
    }
  };
}

export type OutboundApi = ReturnType<typeof createOutboundApi>;
